<template>
  <PaymentInfoCards />
  <div class="mt-4">
    <div class="grid lg:grid-cols-2 md:grid-cols-1 gap-4 sm:grid-cols-1">
      <div class="col-span-1 max-h-[575px] min-h-[575px]">
        <PaymentPlanAnalysis />
      </div>
      <div class="col-span-1 max-h-[575px] min-h-[575px]">
        <PaymentPlanValue />
      </div>
      <div class="col-span-1 max-h-[575px] min-h-[575px]">
        <PaymentAnalysis />
      </div>
      <div class="col-span-1 max-h-[575px] min-h-[575px]">
        <PaymentValue />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PaymentAnalysis from '../graphs/payment-analysis/PaymentAnalysis.vue';
import PaymentPlanAnalysis from '../graphs/payment-plan-analysis/PaymentPlanAnalysis.vue';
import PaymentPlanValue from '../graphs/payment-plan-value/PaymentPlanValue.vue';
import PaymentValue from '../graphs/payment-value/PaymentValue.vue';
import PaymentInfoCards from '../payment-info-cards/PaymentInfoCards.vue';
</script>
